(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aroma-product-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-product-extras')) {
  customElements.define('av-product-extras', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.key = 'aroma-viva-favorites-v1';
      this.feedback = this.querySelector('[data-feedback]');
      this.dialog = this.querySelector('dialog');
      this.refresh();
      this.querySelector('[data-favorite-toggle]').addEventListener('click', () => this.toggleFavorite(), options);
      this.querySelector('[data-favorites-open]').addEventListener('click', () => { this.renderFavorites(); this.dialog.showModal(); }, options);
      this.querySelector('[data-favorites-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, options);
      this.querySelector('[data-favorites-list]').addEventListener('click', (event) => {
        const remove = event.target.closest('[data-remove-favorite]');
        if (remove && this.save(this.read().filter(item => item.id !== remove.dataset.removeFavorite))) this.renderFavorites();
      }, options);
      this.querySelector('[data-instagram-share]').addEventListener('click', () => this.shareInstagram(), options);
      window.addEventListener('storage', () => this.refresh(), options);
      window.addEventListener('av:favorites', () => this.refresh(), options);
      this.deliveryButton = this.closest('form')?.querySelector('.product-add-to-cart .add-to-cart');
      this.deliveryObserver?.disconnect();
      if (this.deliveryButton) {
        this.deliveryObserver = new MutationObserver(() => this.updateDelivery());
        this.deliveryObserver.observe(this.deliveryButton, { attributes: true, attributeFilter: ['disabled'] });
      }
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.scheduleDelivery(); }, options);
      this.scheduleDelivery();
    }
    disconnectedCallback() { this.abort?.abort(); this.deliveryObserver?.disconnect(); clearTimeout(this.deliveryTimer); }
    deliveryEstimate(now) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Sofia', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(now).map(part => [part.type, part.value]));
      const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
      const weekend = date.getUTCDay() === 0 || date.getUTCDay() === 6;
      const kind = weekend ? 'weekend' : Number(parts.hour) < 15 ? 'before' : 'after';
      if (weekend) {
        do { date.setUTCDate(date.getUTCDate() + 1); } while (date.getUTCDay() === 0 || date.getUTCDay() === 6);
      }
      let days = kind === 'after' ? 2 : 1;
      while (days > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) days -= 1;
      }
      return { date, kind };
    }
    updateDelivery() {
      const title = this.querySelector('[data-delivery-title]');
      const dateElement = this.querySelector('[data-delivery-date]');
      const hint = this.querySelector('[data-delivery-hint]');
      if (this.dataset.deliveryPreorder === 'true' || !this.deliveryButton || this.deliveryButton.disabled) {
        title.textContent = this.dataset.deliveryTitle;
        dateElement.hidden = true;
        hint.textContent = this.dataset.deliveryFallback;
        return;
      }
      const estimate = this.deliveryEstimate(new Date());
      title.textContent = this.dataset.deliveryLabel;
      dateElement.dateTime = estimate.date.toISOString().slice(0, 10);
      dateElement.textContent = new Intl.DateTimeFormat(this.dataset.deliveryLocale || 'bg', {
        weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
      }).format(estimate.date);
      dateElement.hidden = false;
      hint.textContent = this.dataset['delivery' + estimate.kind[0].toUpperCase() + estimate.kind.slice(1)];
    }
    scheduleDelivery() {
      clearTimeout(this.deliveryTimer);
      this.updateDelivery();
      this.deliveryTimer = setTimeout(() => this.scheduleDelivery(), 60000 - Date.now() % 60000 + 50);
    }
    read() {
      try {
        const data = JSON.parse(localStorage.getItem(this.key) || '[]');
        return Array.isArray(data) ? data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && new URL(item.url, location.origin).origin === location.origin).slice(0, 100) : [];
      } catch { return []; }
    }
    save(items) {
      try { localStorage.setItem(this.key, JSON.stringify(items)); window.dispatchEvent(new Event('av:favorites')); return true; }
      catch { this.feedback.textContent = this.dataset.storageError; return false; }
    }
    refresh() {
      const items = this.read();
      const saved = items.some(item => item.id === this.dataset.productId);
      this.querySelector('[data-favorite-toggle]').setAttribute('aria-pressed', String(saved));
      this.querySelector('[data-favorite-label]').textContent = saved ? this.dataset.savedLabel : this.dataset.addLabel;
      this.querySelector('[data-favorites-count]').textContent = String(items.length);
    }
    toggleFavorite() {
      const items = this.read();
      const saved = items.some(item => item.id === this.dataset.productId);
      const next = saved ? items.filter(item => item.id !== this.dataset.productId) : [{ id: this.dataset.productId, title: this.dataset.productTitle, url: this.dataset.productUrl, image: this.dataset.productImage }, ...items].slice(0, 100);
      if (this.save(next)) this.feedback.textContent = '';
    }
    renderFavorites() {
      const list = this.querySelector('[data-favorites-list]');
      list.replaceChildren();
      const items = this.read();
      if (!items.length) { const li = document.createElement('li'); li.textContent = this.dataset.emptyLabel; list.append(li); return; }
      items.forEach(item => {
        const li = document.createElement('li');
        const link = document.createElement('a'); link.href = item.url;
        if (item.image) {
          try { const url = new URL(item.image, location.origin); if (url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com')) { const img = document.createElement('img'); img.src = url.href; img.alt = ''; img.width = 48; img.height = 64; img.loading = 'lazy'; link.append(img); } } catch {}
        }
        const title = document.createElement('span'); title.textContent = item.title; link.append(title);
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = this.dataset.removeLabel; remove.dataset.removeFavorite = item.id; remove.setAttribute('aria-label', this.dataset.removeLabel + ': ' + item.title);
        li.append(link, remove); list.append(li);
      });
    }
    async shareInstagram() {
      const data = { title: this.dataset.productTitle, text: this.dataset.productTitle, url: this.dataset.productUrl };
      if (navigator.share) {
        try { await navigator.share(data); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      try { await navigator.clipboard.writeText(data.url); this.feedback.textContent = this.dataset.copiedLabel; }
      catch { const fallback = this.querySelector('[data-share-fallback]'); fallback.hidden = false; const input = fallback.querySelector('input'); input.focus(); input.select(); this.feedback.textContent = this.dataset.copyFallback; }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
